import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

export const GET_CHANGESET_ATTRIBUTES_KEY = 'GET_CHANGESET_ATTRIBUTES_KEY';

interface AttributePayload {
  attribute_name?: string;
  type?: string;
  label?: string;
}

interface Attribute {
  attributeName?: string;
  type?: string;
  label?: string;
}

export const useGetChangesetAttributesQuery = (changesetId?: string, enabled?: boolean) => {
  const { data, isLoading, refetch } = useQuery(
    [GET_CHANGESET_ATTRIBUTES_KEY, changesetId, enabled],
    // TODO: this DTO type is missing
    () => api.get<AttributePayload[]>(API_URL.AUDIT_CHANGESETS_ATTRIBUTES_BY_CHANGESET_ID(changesetId || '')),
    {
      enabled,
    }
  );

  const attributes = useMemo<Attribute[] | undefined>(
    () =>
      data?.data?.map((item) => ({
        attributeName: item?.attribute_name,
        type: item?.type,
        label: item?.label,
      })),
    [data]
  );

  return {
    attributes,
    isLoading,
    refetch,
  };
};
